
<div class="flex items-center gap-1">
    <ng-container *ngIf="hasRoleSplit; else singleGroup">
    <div class="flex -space-x-2 items-center">
      <ng-container *ngFor="let usr of visibleManagers; trackBy: trackByFn">
        <ng-container *ngIf="usr.pic; else initialsMgr">
          <img class="shrink-0 rounded-full border object-cover hover:z-10 relative {{customClass}}" [ngClass]="avatarSizeClass" [src]="usr.pic" [matTooltip]="showTooltip ? usr.displayName : null" alt="User" />
        </ng-container>
        <ng-template #initialsMgr>
          <span class="shrink-0 rounded-full border flex items-center justify-center font-medium text-[10px] uppercase hover:z-10 relative {{customClass}}" [ngClass]="avatarSizeClass" [matTooltip]="showTooltip ? usr.displayName : null" [ngStyle]="{'background-color': appUtilService.getRandomColor(usr.displayName), 'color': appUtilService.getTextColor(usr.displayName)}">{{ appUtilService.transformTitle(usr.displayName, charLength) }}</span>
        </ng-template>
      </ng-container>
      <div *ngIf="showRemaining && remainingManagersCount > 0" [ngClass]="avatarSizeClass" class="shrink-0 rounded-full ring-1 ring-white flex items-center justify-center font-medium text-[10px] uppercase hover:z-10 relative cursor-pointer bg-[#F3F4F6] text-[#4A5565] size-[22px]" [matTooltip]="getRemainingNames(managerList)">+{{ remainingManagersCount }}</div>
    </div>
    <div class="w-px h-6 bg-[#E3E6EE] shrink-0 mx-0.5" aria-hidden="true"></div>
    <div class="flex -space-x-2 items-center">
      <ng-container *ngFor="let usr of visibleMembers; trackBy: trackByFn">
        <ng-container *ngIf="usr.pic; else initialsMem">
          <img class="shrink-0 rounded-full border object-cover hover:z-10 relative {{customClass}}" [ngClass]="avatarSizeClass" [src]="usr.pic" [matTooltip]="showTooltip ? usr.displayName : null" alt="User" />
        </ng-container>
        <ng-template #initialsMem>
          <span class="shrink-0 rounded-full border flex items-center justify-center font-medium text-[10px] uppercase hover:z-10 relative {{customClass}}" [ngClass]="avatarSizeClass" [matTooltip]="showTooltip ? usr.displayName : null" [ngStyle]="{'background-color': appUtilService.getRandomColor(usr.displayName), 'color': appUtilService.getTextColor(usr.displayName)}">{{ appUtilService.transformTitle(usr.displayName, charLength) }}</span>
        </ng-template>
      </ng-container>
      <div *ngIf="showRemaining && remainingMembersCount > 0" [ngClass]="avatarSizeClass" class="shrink-0 rounded-full ring-1 ring-white flex items-center justify-center font-medium text-[10px] uppercase hover:z-10 relative cursor-pointer bg-[#F3F4F6] text-[#4A5565] size-[22px]" [matTooltip]="getRemainingNames(memberList)">+{{ remainingMembersCount }}</div>
    </div>
  </ng-container>
  <ng-template #singleGroup>
    <div class="flex -space-x-2">
    <ng-container *ngFor="let usr of userList.slice(0, maxVisible); trackBy: trackByFn">
      <ng-container *ngIf="usr.pic; else Initials">
        <img
          class="shrink-0 rounded-full border object-cover hover:z-10 relative {{customClass}}"
          [ngClass]="avatarSizeClass"
          [src]="usr.pic"
        [matTooltip]="showTooltip ? usr.displayName : null"
          alt="User" />
      </ng-container>
<!--          matTooltip ="{{usr.displayName}}"-->
<!--          [attr.title]="name"-->


      <ng-template #Initials>
        <span
          class="shrink-0 rounded-full border flex items-center justify-center font-medium text-[10px] uppercase hover:z-10 relative {{customClass}}"
          [ngClass]="avatarSizeClass"
          [matTooltip]="showTooltip ? usr.displayName : null"
          [ngStyle]="{
                    'background-color': appUtilService.getRandomColor(usr.displayName),
                    'color': appUtilService.getTextColor(usr.displayName)
  }">
          {{ appUtilService.transformTitle(usr.displayName, charLength) }}
        </span>
      </ng-template>
    </ng-container>
    <!-- Show +N with tooltip for remaining users -->

    <div
      *ngIf="showRemaining && userList.length > maxVisible"
      [ngClass]="avatarSizeClass"
      class="shrink-0 rounded-full ring-1 ring-white flex items-center justify-center font-medium text-[10px] uppercase hover:z-10 relative cursor-pointer bg-[#F3F4F6] text-[#4A5565] size-[22px]"
      [matTooltip]="getRemainingNames(userList)"
    >
      +{{ userList.length - maxVisible }}
    </div>
    </div>
  </ng-template>





<!-- <div class="flex items-center hidden"
     [ngClass]="{
       '-space-x-2': layout === 'group',
       'gap-x-2': layout === 'list'
     }">

  <ng-container *ngFor="let avatar of avatar.slice(0, maxVisible); let i = index">
    <div *ngIf="layout === 'list'; else groupView" class="flex items-center gap-2">
      <ng-container *ngIf="avatar; else listInitials">
        <img
          class="shrink-0 rounded-full ring-1 ring-white object-cover"
          [ngClass]="avatarSizeClass"
          [src]="avatar"

          alt="User" />
      </ng-container>
      <ng-template #listInitials>
        <span
          class="shrink-0 rounded-full ring-1 ring-white bg-[{{'#141414'}}] text-gray-700 flex items-center justify-center font-medium text-xs uppercase"
          [ngClass]="avatarSizeClass"
          >
          {{ appUtilService.transformTitle(name[0], 1) }}
        </span>
      </ng-template>

      <div>
        <span *ngIf="showNames && name[i]" class="font-medium text-sm text-[#15191E]">{{ name[i] }}</span>
        <span *ngIf="showEmails && emails[i]" class="block text-sm text-[#15191E]">{{ emails[i] }}</span>
      </div>
    </div>

    <ng-template #groupView>
      <ng-container *ngIf="avatar; else groupInitials">
        <img
          class="shrink-0 rounded-full ring-1 ring-white object-cover hover:z-10 relative"
          [ngClass]="avatarSizeClass"
          [src]="avatar"
          [attr.title]="getTooltip(i)"
          alt="User" />
      </ng-container>
      <ng-template #groupInitials>
        <span
          class="shrink-0 rounded-full ring-2 ring-white bg-[{{'#141414'}}] text-gray-700 flex items-center justify-center font-medium text-xs uppercase hover:z-10 relative"
          [ngClass]="avatarSizeClass"
          [attr.title]="getTooltip(i)">
          {{ getInitials(i) }}
        </span>
      </ng-template>
    </ng-template>
  </ng-container>

  <span *ngIf="avatar.length > maxVisible"
        class="flex items-center justify-center shrink-0 rounded-full ring-2 ring-white bg-gray-200 text-xs font-semibold text-gray-700 hover:z-10 relative"
        [ngClass]="avatarSizeClass"
        [attr.title]="getRemainingTooltip()">
    +{{ avatar.length - maxVisible }}
  </span>

  <span *ngIf="showAddButton"
        class="flex items-center justify-center shrink-0 rounded-full bg-white ring-1 ring-white border border-dashed border-[#D6D7DC] cursor-pointer hover:z-10 relative"
        [ngClass]="avatarSizeClass"
        (click)="onAddClick()">
    <img src="assets/images/icons/ticket-detail/add-profile.svg" alt="">
  </span>
</div> -->
